import { pushToDataLayer } from '../utils/pushToDataLayer';
import { GACustomEvent } from '../utils/types';

export function newsletterSignup(formType: string) {
    pushToDataLayer({
        event: GACustomEvent.NewsletterSignup,
        form_type: formType.toLowerCase(),
    });
}
